import FilterFramesIcon from "@mui/icons-material/FilterFrames";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useRouter } from "../../hooks/useRouter";
import { ROUTES } from "../../routes";
import { useLocation } from 'react-router-dom';

const WhiteBoardButton = () => {
  const location_route = useLocation();
  const { t } = useTranslation();
  const { push, location } = useRouter();
  const handleBtnClick = () => {
    push(ROUTES.WHITEBOARD_PAGE, location_route.search);
  };
  const isActive = location.pathname === ROUTES.WHITEBOARD_PAGE;

  return (
    <Tooltip
      title={t("WhiteBoard_Button")}
      placement="bottom"
      arrow
      disableInteractive
    >
      <IconButton
        aria-label="invite"
        onClick={handleBtnClick}
        color={isActive ? "primary" : "default"}
        sx={{ padding: "5px", '&:hover': {backgroundColor: 'transparent' }}}
      >
        <FilterFramesIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};

export default WhiteBoardButton;
